import { Component, inject, input, output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_DROPDOWNLIST } from '@progress/kendo-angular-dropdowns';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { TransitionMiniDto, TransitionRequestDto } from '@unity/clients';
import { IconService } from '@unity/services/icon.service';
import { ActionTransitionSharedComponent } from '@unity/shared/composed/action-transition-shared/action-transition-shared.component';

@Component({
  selector: 'unity-workflow-selector-shared',
  imports: [KENDO_GRID, KENDO_DROPDOWNLIST, KENDO_BUTTON, ReactiveFormsModule, ActionTransitionSharedComponent],
  templateUrl: './workflow-selector-shared.component.html',
  styleUrl: './workflow-selector-shared.component.scss',
})
export class WorkflowSelectorSharedComponent {
  private readonly iconService = inject(IconService);

  protected worflowIcon = this.iconService.arrowRightIcon;

  public readonly $transitions = input.required<TransitionMiniDto[] | undefined>({ alias: 'transitions' });
  public readonly $disabled = input.required<boolean>({ alias: 'disabled' });

  public workflowEvent = output<TransitionRequestDto>();

  protected onTransition = (dto: TransitionRequestDto) => this.workflowEvent.emit(dto);
}
